import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, withModifiers as _withModifiers, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c09eeb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "w-column-primary" }
const _hoisted_3 = { class: "tech-flex" }
const _hoisted_4 = { class: "nonestrict-left" }
const _hoisted_5 = { class: "operational" }
const _hoisted_6 = { class: "todo-current" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mn-person-stopped" }, " STOPPED ", -1))
const _hoisted_8 = {
  key: 0,
  class: "todo-desk"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-90deg-down" }, null, -1))
const _hoisted_11 = ["onDrop"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_13 = {
  key: 2,
  class: "history-footer"
}
const _hoisted_14 = { class: "w-column-aux" }
const _hoisted_15 = { class: "w-topbar-aux-2" }

import * as sys from '@/sys'
import { onUnmounted, reactive, onBeforeMount } from 'vue';
import { useAppContext } from '@/app/_tech';
import TicketCard from '@/components/Workspaces/tickets/_spec/TicketCard.vue';
import { computed } from '@vue/reactivity';
import QueueComponent from '@/app/workspace/components/QueueComponent.vue'
import { Sunrise } from '@/logic/_infra/time'
import TicketStand from '@/components/Workspaces/todos/_spec/TicketStand.vue'
import TicketSlot from '@/components/Workspaces/persons/_spec/TicketSlot.vue'
import { personEndeavoursStrings } from '@/controllers/workspaces/person.controller'
import { PersonRmodel } from '@/app.context/workspace/person.rmodel';
import setupPersonView from '@/controllers/workspaces/person.controller'
import { Desk } from '@/controllers/workspaces/person.controller'
import { TqueuePosition } from '@/logic/_infra/queues';
import TicketSummary from '@/components/Workspaces/tickets/_spec/TicketSummary.vue';
import { TodoRmodel } from '@/app.context/workspace/tickets/todo.rmodel';
import { dragEventRef } from '@/controllers/workspaces/tickets/_spec/ticket.item.controller';
import { TicketAccessLevel } from '@/controllers/workspaces/user.controller.workspace';
import { ticketUpdateController_Alt } from '@/controllers/workspaces/tickets/_spec/ticket.controller.chat'
import EventComponent from '@/components/Workspaces/persons/_spec/EventComponent.vue';
import GridComponent from '@/app/workspace/components/GridComponent.vue'
import { BoardPosition } from '@/logic/_infra/boards'
import { TicketRmodel } from '@/app.context/workspace/ticket.rmodel';
import { Entity } from '@/logic/workspaces/_tech'
import { TodoUiElementController } from '@/components/Workspaces/todos/_spec/todo.controller.basic'
import UserEdeavoursControl from '@/components/Workspaces/users/_spec/UserEdeavoursControl.vue'
import { ISunriseReportDto } from '@/io/dto/workspaces/persons/sunriseReport.dto';
import { EffortSummary, SunriseReportRmodel } from '@/app.context/workspace/persons/sunrise.rmodel';
import  EffortStatusComponent from '@/app/workspace/person/timeline/EffortStatusComponent.vue'

import TopbarComponent from '@/app/workspace/person/TopbarControl.Person.vue'

import * as personController from '@/ops/workspaces/person.processor'




import { boards } from '@/logic/_infra/boards';
import { TicketItemModel } from '@/app.context/workspace/tickets/_spec/Ticket.Item.Model';

import * as workspaceProcessor from '@/ops/workspace.processor'
import * as ticketProcessor from '@/ops/workspaces/ticket.processor'
import * as personProcessor from '@/ops/workspaces/person.processor'
import userVueController from '@/components/Workspaces/users/_spec/user.controller.vue'
import { isTicket, isTodo } from '@/controllers/workspaces/tickets/_model/ticket.item.controller';
import { minuteCalc as mc } from '@/logic/_infra/time'
import { IEntityRefDto } from '@/io/dto/workspaces/_tech';


type TaskOperation = "Complete" | "Fail" | "Block";


//Model of CURRENT todo/ticket at person view

export default /*#__PURE__*/_defineComponent({
  __name: 'PersonSubview',
  props: {
    workspace: {},
    person: {}
  },
  setup(__props: any) {

const context = useAppContext();

//responding for resolution of tickets that NOT in 'current' position
const todoUiController = TodoUiElementController(context)

const todoUiController_alt = TodoUiElementController(context)

todoUiController_alt.close = function (item: TodoRmodel | TicketRmodel): void {

  const p = person_model.value

  if (p != null) {
    const ops = context.ops.xbq!;

    if (item instanceof TodoRmodel) {

      ops.todoBoardClose(item, p)

    }
  }
}


const person_endeavours = computed(() => person_model.value != null ? personEndeavoursStrings(person_model.value) : [])
const person_endeavours_total = computed(() => person_model.value != null ? mc.toAproximatedHoursString(person_model.value.endeavours_total()) : '')

const person_endeavours_balance = computed(function () {

  const p = person_model.value;

  if (p == null) return 0;

  return p.endeavours_balance()



})



const props = __props

const options = { board: false /*context.cursor.person?.IsStrictSuborinate() ?? true*/ }

const data:
  {
    abscense: boolean,
    ticket: TicketItemModel,
    ticket_aux: TicketItemModel,
    operation: TaskOperation | null, //when we in intermediate step - when 'complete/fail/blcok' is clicked on ticket but NOT yet 'confirmed/canceled'
    todo_upcoming: TodoRmodel | null, //pre-picked ticket - from 'desk'

  } = reactive({ abscense: false, ticket: reactive(new TicketItemModel()), ticket_aux: reactive(new TicketItemModel()), operation: null, todo_upcoming: null });



const model:
  {
    endeavours: number[],
    //efforts_header: SunriseReportRmodel | null,
    efforts: SunriseReportRmodel[],
    efforts_predecessing: Sunrise | null,
    desk: Desk
  } = reactive({ endeavours: [], efforts_header: null, efforts: [], efforts_predecessing: null, desk: new Desk() })

const person_model = computed(() => { return context.cursor.person })


const { user_level } = userVueController(context)



const user_level_board = computed(() => {

  if (context.cursor.person != null) {

    if (context.cursor.person.hasUser) {
      if (context.isCurrentPerson()) return TicketAccessLevel.Full
    }
    else if (context.isCaptain()) return TicketAccessLevel.Full
  }

  return TicketAccessLevel.None
})


const f =
{
  persons() { return context.cursor.workspace?.persons(context.cursor?.person ?? undefined) ?? [] },
  projects() { return context.cursor.workspace?.projects(/*context.cursor?.project ?? undefined*/) ?? [] },
  personsAll() { return context.cursor.workspace?.persons() ?? [] },

}

const persons_exeptional = computed(() => f.persons())

ticketUpdateController_Alt(context, data.ticket_aux)

setupPersonView(setupInternal, setupPreliminary, props, data)

function setupPreliminary() {

  data.ticket_aux.disposeIf()

  model.efforts.length = 0
  model.efforts_predecessing = null

  //console.log('RESET OF EFFORTS') //#DEV/TRACING
}

function setupInternal(p: PersonRmodel) {

  const w = p.workspace;

  // -- Setup handling for change queue 'current' task -- //

  w.persons().forEach(p => {

    p.handler_CurrentTodoCleared = null;
    p.handler_CurrentTodoSet = null;
  })

  p.handler_CurrentTodoCleared = (p) => resetTicketContextIf();
  p.handler_CurrentTodoSet = (todo) => setupCurrentTodo(todo.task.person)

  setupCurrentTodo(p)

  // -- END -- Setup handling... //



  //model.efforts_header = p.efforts

  if (p.efforts != null) {

    //model.efforts.push(p.efforts)
    //model.efforts_header = p.efforts

    if (p.efforts.predecessor != null) {



      context.service.personEfforts(p.nid, p.efforts.predecessor)
        .then(r => {

          setupEffortsLog(p, r)

          model.endeavours.length = 0;
        })
        .catch(reason => {

          sys.exception(reason, '/workspaces/person - History')

          setupPreliminary()

        });
    }
  }
}

// --- SYSTEM TRIGGERS --- //

const handlers: { handler: globalThis.EventListenerOrEventListenerObject, type: string }[] = [];

onUnmounted(() => {

  handlers.forEach(h => context.triggers.cancel(h)); //usubscribe all evernts by mountd instance

  data.ticket.storage?.disconnect()
})

onBeforeMount(() => {

  handlers.push(context.triggers.onCommand((command) => {

    //console.log(`Person ${person_model.value?.name} context - command: ${command}`) ////#DEV/TRACING

    const p = context.cursor.person;

    if (p == null) sys.error("Context person is empty")
    else {
      const title = command;

      workspaceProcessor.commandSubmit(context, title, p.workspace.wid, Entity.Person, p.nid)

    }

  }))

});

ticketUpdateController_Alt(context, data.ticket)

// -- UI TRIGGERS -- //

function setupEffortsLog(p: PersonRmodel, dto: ISunriseReportDto) {



  const report = SunriseReportRmodel.Instance(p, dto.period, dto, context)

  model.efforts.push(report)

  if (report.predecessor != null) {

    //const report_last = reports[reports.length - 1]

    model.efforts_predecessing = report.predecessor

  } else model.efforts_predecessing = null
}

function onMoreHistoryClick() {

  if (model.efforts_predecessing != null) {
    const person = context.cursor.person!;

    context.service.personEfforts(person.nid, model.efforts_predecessing)
      .then(r => setupEffortsLog(person, r))
      .catch(sys.exception)
  }
  else sys.warn("There is no previous history")
}

function onTodoOperation($event: TaskOperation | null) {

  data.todo_upcoming = null

  data.operation = $event
}

function onResume() {

  let item = data.todo_upcoming;

  if (item == null) item = person_model.value!.todo_next()

  if (item != null) personController.queueEntity_todo(context, item, new TqueuePosition("current"))

  else sys.warn('Null todo on resume')


}

function onTimelinerUpdated(value: number[]) {

}

// -- SHARED -- //
/**
 * Setup person subview for current ticket (loads chat, ticket panel, etc.)
 * @param person 
 */
function setupCurrentTodo(person: PersonRmodel) {

  if (person == null) Error('cursor.perso in null whlie setupCurrentTodo')

  // description text
  //chat connection 

  if (person.current != null) {
    //some task to setup
    const todo = person.current;

    data.ticket.set(todo.task.ticket, context)
    data.ticket.todo = todo

  }
  else resetTicketContextIf();
}

function resetTicketContextIf() {


  data.ticket.disposeIf();
}


function isCurrentAuxTicket(t: TicketRmodel | TodoRmodel) {

  if (isTicket(t)) return (data.ticket_aux.ticket?.n == t.n)

  else if (isTodo(t)) return (data.ticket_aux.ticket?.n == t.ticket.n)

  else throw Error('Unknow type')
}

function isCurrentTicket(t: TicketRmodel | TodoRmodel) {

  if (isTicket(t)) return (data.ticket.ticket?.n == t.n)

  else if (isTodo(t)) return (data.ticket.ticket?.n == t.ticket.n)

  else throw Error('Unknow type')
}



function setAuxTicket(entity: TodoRmodel | TicketRmodel) {
  data.ticket_aux.set(entity, context)
}

function resetAuxTicket() {
  data.ticket_aux.disposeIf()


}

// -- SHARED -- END --//

function todoPopup(entity: TodoRmodel | TicketRmodel) {

  if (isCurrentAuxTicket(entity)) resetAuxTicket()
  else if (isCurrentTicket(entity)) resetAuxTicket()
  else setAuxTicket(entity)
}

function onTicketPick(t: TodoRmodel) {

  if (t === data.todo_upcoming) data.todo_upcoming = null; else data.todo_upcoming = t;

}

function contextPersonOrLogWarning() {

  if (context.cursor.person == null) Error('Person is null while OnCompleteClick')

  return context.cursor.person;


}

function onBoardAdd(position: BoardPosition) {

  const p = contextPersonOrLogWarning();

  if (p) {

    if (p.user != null && p.user != context.model.user?.uid) return;

    const title = context.ui.consoleContent();



    workspaceProcessor.commandSubmit(context, title, p.workspace.wid, Entity.Person, p.nid)
    //operator.commandSubmit(title, p.workspace.wid, Entity.Person, p.nid)

    context.ui.consoleContentClear();
  }
}

function onGridDrop(ref: IEntityRefDto, position: BoardPosition) {

  const person = context.cursor.person!

  const item = person.todoItemOrNull(ref.n, ref.type!, ref.person_aux) //.workspace.ticket(ref.n)

  if (item != null) {

    const target = boards.itemOrNull(person.board.person, position)

    if (target != null) {

      sys.warn('Swap operation is not impemented')
    }
    else {
      context.ops.xbq!.todoBoard(item, person, position)
    }

  }
  else sys.warn(`/workspaces/person - Board - Can't find ref ${ref.n}`)



}


function onDeskStripsDrop(ref: IEntityRefDto, index: number) { personController.queueEntity(context, person_model.value!, ref, new TqueuePosition("desk", index)) }

function onQueueDrop(ref: IEntityRefDto, index: number) { personController.queueEntity(context, person_model.value!, ref, new TqueuePosition("queue", index)) }

function onPinsDrop(ref: IEntityRefDto, index: number) { personController.queueEntity(context, person_model.value!, ref, new TqueuePosition("pins", index)) }

function onDeskCardDrop(e: DragEvent, index: number) {

  const p = person_model.value!;

  const ref = dragEventRef(e)

  if (ref != null) personController.queueEntity(context, p, ref, new TqueuePosition("desk", index))
}

function onDeskCardDragLeave(e: DragEvent) {

  const target = e.target;

  const element = target as HTMLElement

  element.classList.remove('dev-box')
}

function onDeskCardDragOver(e: DragEvent) {

  const target = e.target;

  const element = target as HTMLElement

  element.classList.remove('dev-box')
}

function onDeskCardDragEnter(e: DragEvent) {

  const target = e.target;

  const element = target as HTMLElement

  element.classList.remove('dev-box')
}

function onTicketCommand(command: string, ticket: TicketRmodel) {

  ticketProcessor.commandSubmitOnTicket2(context, command, ticket)

}

function stop(p: PersonRmodel, value: boolean) {

  personProcessor.stop(context, p, value)
}





return (_ctx: any,_cache: any) => {
  return (_unref(person_model) != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(TopbarComponent, {
            class: "w-topbar-aux",
            person: _unref(person_model),
            notifications: [],
            level: _unref(user_level)
          }, null, 8, ["person", "level"]),
          _createElementVNode("div", _hoisted_3, [
            (data.ticket.ticket)
              ? _withDirectives((_openBlock(), _createBlock(TicketSummary, {
                  key: 0,
                  model: data.ticket,
                  files: _unref(context).storages.files,
                  level: _unref(user_level)
                }, null, 8, ["model", "files", "level"])), [
                  [_vShow, data.ticket_aux.ticket == null]
                ])
              : _createCommentVNode("", true),
            (data.ticket_aux.ticket)
              ? (_openBlock(), _createBlock(TicketSummary, {
                  key: 1,
                  model: data.ticket_aux,
                  files: _unref(context).storages.files,
                  level: _unref(user_level),
                  escape: true,
                  onClose: _cache[0] || (_cache[0] = ($event: any) => (data.ticket_aux.disposeIf()))
                }, null, 8, ["model", "files", "level"]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", _hoisted_4, [
              _createVNode(GridComponent, {
                class: "grid",
                matrix: _unref(person_model).board.person,
                x4: true,
                onAdd: onBoardAdd,
                onClick: todoPopup,
                controller: _unref(todoUiController_alt),
                onDrop: onGridDrop,
                level: _unref(user_level_board),
                "circled-x": true,
                focused: null,
                focused_index: null,
                files: null
              }, null, 8, ["matrix", "controller", "level"])
            ], 512), [
              [_vShow, (data.ticket.ticket == null || options.board) && data.ticket_aux.ticket == null]
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(EventComponent, {
                  person: _unref(person_model),
                  level: _unref(user_level)
                }, null, 8, ["person", "level"]),
                (_unref(person_model).subordinate && _unref(person_model).stopped)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_7,
                      _createElementVNode("button", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (stop(_unref(person_model), false)))
                      }, "Unstop")
                    ], 64))
                  : _createCommentVNode("", true),
                (_unref(person_model).current != null)
                  ? (_openBlock(), _createBlock(TicketStand, {
                      key: 1,
                      onUpdated: _cache[2] || (_cache[2] = ($event: any) => (setupCurrentTodo(_unref(person_model)))),
                      onOperation: onTodoOperation,
                      onClick: _cache[3] || (_cache[3] = () => data.ticket_aux.disposeIf()),
                      level: _unref(user_level),
                      upcoming: data.todo_upcoming,
                      person: _unref(person_model),
                      persons: _unref(persons_exeptional),
                      highlight: data.ticket_aux.ticket != null
                    }, null, 8, ["level", "upcoming", "person", "persons", "highlight"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (_unref(person_model).IsStrictSuborinate())
                        ? (_openBlock(), _createBlock(TicketSlot, {
                            key: 0,
                            person_model: _unref(person_model),
                            level: _unref(user_level),
                            onResume: onResume
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" [Idle] ")
                            ]),
                            _: 1
                          }, 8, ["person_model", "level"]))
                        : (_unref(person_model).subordinate)
                          ? (_openBlock(), _createBlock(TicketSlot, {
                              key: 1,
                              person_model: _unref(person_model),
                              class: "mn-ticket-current-spaceholer",
                              level: _unref(user_level)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" [CURRENT] ")
                              ]),
                              _: 1
                            }, 8, ["person_model", "level"]))
                          : _createCommentVNode("", true)
                    ], 64))
              ]),
              (_unref(person_model).IsStrictSuborinate())
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(person_model).desk, (t, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: t.key
                      }, [
                        (data.operation || _unref(person_model).current == null)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "clickable text-center",
                              onClick: ($event: any) => (onTicketPick(t))
                            }, [
                              _hoisted_10,
                              _createTextVNode("Pick "),
                              _withDirectives(_createElementVNode("span", null, "[X]", 512), [
                                [_vShow, data.todo_upcoming === t]
                              ])
                            ], 8, _hoisted_9))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          onDragenter: _withModifiers(onDeskCardDragEnter, ["prevent"]),
                          onDragover: _withModifiers(onDeskCardDragOver, ["prevent"]),
                          onDragleave: onDeskCardDragLeave,
                          onDrop: ($event: any) => (onDeskCardDrop($event, index))
                        }, [
                          _createVNode(TicketCard, {
                            class: "card-current",
                            todo: t,
                            level: _unref(user_level),
                            "circled-x": true,
                            onClick: ($event: any) => (todoPopup(t)),
                            onPerson: (person, index) => _unref(todoUiController).person(t, person, index),
                            onBlock: _cache[4] || (_cache[4] = (b) => _unref(todoUiController).block(b)),
                            onX: ($event: any) => (_unref(todoUiController).close(t)),
                            onV: ($event: any) => (_unref(todoUiController).check(t)),
                            onCommand: onTicketCommand
                          }, null, 8, ["todo", "level", "onClick", "onPerson", "onX", "onV"])
                        ], 40, _hoisted_11)
                      ], 64))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _hoisted_12,
              (_unref(person_model).efforts != null)
                ? (_openBlock(), _createBlock(EffortStatusComponent, {
                    key: 1,
                    status: _unref(person_model).efforts.summary,
                    showOverlaps: true,
                    log: model.efforts
                  }, null, 8, ["status", "log"]))
                : _createCommentVNode("", true),
              (model.efforts_predecessing != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("i", {
                      style: {"font-size":"x-large"},
                      class: "bi bi-arrow-down-circle clickable",
                      onClick: onMoreHistoryClick
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(UserEdeavoursControl, {
              items: _unref(person_endeavours),
              class: "endeavours"
            }, null, 8, ["items"]),
            _createTextVNode("   "),
            (_unref(person_endeavours).length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("(" + _toDisplayString(_unref(person_endeavours_total)) + ")", 1)
                ], 64))
              : _createCommentVNode("", true),
            (_unref(person_endeavours_balance) != 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" [" + _toDisplayString(_unref(mc).toAproximatedHoursString(_unref(person_endeavours_balance))) + "]", 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          (!_unref(person_model).strict)
            ? (_openBlock(), _createBlock(QueueComponent, {
                key: 0,
                class: "w-subqueue",
                todos: _unref(person_model).desk,
                controller: _unref(todoUiController),
                onClickStrip: todoPopup,
                onDrop: onDeskStripsDrop,
                level: _unref(user_level),
                onCommand: onTicketCommand,
                prefix: _unref(person_model).name,
                "circled-x": true,
                files: _unref(context).storages.files
              }, null, 8, ["todos", "controller", "level", "prefix", "files"]))
            : _createCommentVNode("", true),
          _createVNode(QueueComponent, {
            class: "w-subqueue",
            todos: _unref(person_model).queue,
            onClickStrip: todoPopup,
            controller: _unref(todoUiController),
            onDrop: onQueueDrop,
            level: _unref(user_level),
            prefix: _unref(person_model).name,
            "circled-x": true,
            onCommand: onTicketCommand,
            files: _unref(context).storages.files
          }, null, 8, ["todos", "controller", "level", "prefix", "files"]),
          _createVNode(QueueComponent, {
            class: "w-subqueue",
            todos: _unref(person_model).pins,
            onClickStrip: todoPopup,
            controller: _unref(todoUiController),
            onDrop: onPinsDrop,
            level: _unref(user_level),
            prefix: _unref(person_model).name,
            "circled-x": true,
            onCommand: onTicketCommand,
            files: _unref(context).storages.files
          }, null, 8, ["todos", "controller", "level", "prefix", "files"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})